import { NumberCell } from "components/common/dataGrid";
import { MaterialPhysics } from "src/store/api/generatedApi";
import { divideByYield } from "./utils";

interface CellProps {
  specificPrice: number | null;
  materialPhysics?: MaterialPhysics;
}

export const LiquidPriceCell = ({
  specificPrice,
  materialPhysics,
}: CellProps) => {
  if (specificPrice === null || materialPhysics === undefined) {
    return <NumberCell value={null} decimalPlaces={2} />;
  }
  return (
    <NumberCell
      value={divideByYield(specificPrice, materialPhysics)}
      decimalPlaces={2}
    />
  );
};
